// Easy Console Logging
function c(i) {
	if(i) {
		console.log(i);
	} else {
		console.log('i like u...<3');
	}
}
// Start jQuery 
jQuery(document).ready(function($) {

	// Touch Device Detection - https://www.billerickson.net/code/touch-screen-detection/
	var isTouchDevice = 'ontouchstart' in document.documentElement;
	if( isTouchDevice ) {
		$('body').removeClass('no-touch');
	}

	// Menu Toggle
	$('#main-menu-toggle').on('click',function(){
		// Menu opening logic
		if($(this).hasClass('open')) { // It's open, so close it
			$(this).attr('aria-expanded', 'false');
			$('#main-nav')
				.removeClass('open')
				.attr('aria-expanded', 'false');
				$('.fa-bars').show();
				$('.fa-times').hide();
		} else { // It's closed, so open it
			$(this).attr('aria-expanded', 'true');
			$('#main-nav')
				.addClass('open')
				.attr('aria-expanded', 'true');
			$('.fa-bars').hide();
			$('.fa-times')
				.show()
				.removeClass('hide');
		}
		// Toggle open class on btn
		$(this).toggleClass('open');
	});

	// Slick Slider
	$('.carousel-wrap').slick({
		arrows: true,
		dots: true,
		mobilefirst: true,
		responsive: [
		    {
		      breakpoint: 9999,
		      settings: 'unslick',
			}, 
			{
		      breakpoint: 640,
			  arrows: true,
			  dots: true,

			},
		]
	});

	// Testimonials
	$('.testimonial-wrap').slick({
		arrows: true,
		dots: true,
	});

	// Back to top
	// https://css-tricks.com/snippets/jquery/smooth-scrolling/
	$('#back-to-top').on('click',function(){
		window.scroll({
		  top: 0, 
		  left: 0, 
		  behavior: 'smooth'
		});
	});

	// Set active tab
	$('#enroll-tabs').on('change.zf.tabs', function() {
		var $active_tab_id = $('.tabs-title.is-active a').attr('aria-controls');
		$('.tabs-content').attr('data-active-panel', $active_tab_id);
	});

	// Comparison Tabs
	if ($(window).width() > 639) {
		   $('.tabs-container.plain').removeClass('tabs');
		   $('.tabs-container.plain #tabs-content-id').removeClass('tabs-content');
		   $('.tabs-container.plain div[id*="panel"]').removeClass('tabs-panel');
		   $('.tabs-container.plain div[id*="panel"]').removeClass('tabs-panel');
		   $( ".tab-content[aria-hidden='true']").attr('aria-hidden', 'false');

	}

	$(window).on('resize', function(){
		if ($(window).width() < 639) {
			$('.tabs-container.plain').addClass('tabs');
			$('.tabs-container.plain #tabs-content-id').addClass('tabs-content');
			$('.tabs-container.plain div[id*="panel"]').addClass('tabs-panel');
			// Foundation.reInit('tabs');
		}
		else {
		   $('.tabs-container.plain').removeClass('tabs');
		   $('.tabs-container.plain #tabs-content-id').removeClass('tabs-content');
		   $('.tabs-container.plain div[id*="panel"]').removeClass('tabs-panel');
		}
	});

	// Aria Label Update to Delineate Carousels
	$('.testimonials-container .carousel-wrap').attr('aria-label', 'testimonial-carousel');

	// Set 'Content' Link
	$('.featured-hero').next('.component-wrap').attr('ID','main-content')


});

// Calculator JS
if(document.querySelector('#calculator-container')) {
	/*
	 *   Switch JS from - https://www.w3.org/WAI/ARIA/apg/patterns/switch/examples/switch/
	 *   Desc:  Switch widget that implements ARIA Authoring Practices
	 */

	'use strict';

	class Switch {
	  constructor(domNode) {
	    this.switchNode = domNode;
	    this.switchNode.addEventListener('click', () => this.toggleStatus());
	    this.switchNode.addEventListener('keydown', (event) =>
	      this.handleKeydown(event)
	    );
	  }

	  handleKeydown(event) {
	    // Only do something when space or return is pressed
	    if (event.key === 'Enter' || event.key === ' ') {
	      event.preventDefault();
	      this.toggleStatus();
	    }
	  }

	  // Switch state of a switch
	  toggleStatus() {
	    const currentState =
	      this.switchNode.getAttribute('aria-checked') === 'true';
	    const newState = String(!currentState);

	    this.switchNode.setAttribute('aria-checked', newState);
	  }
	}

	// Initialize switches
	window.addEventListener('load', function () {
	  // Initialize the Switch component on all matching DOM nodes
	  Array.from(document.querySelectorAll('[role^=switch]')).forEach(
	    (element) => new Switch(element)
	  );
	});

	// End W3C Code / Begin 3D Code
	// - Variables
	let calculator_container = document.querySelector('#calculator-container');
	let screensWrap = document.querySelector('#screens-wrap');
	let calculate_button = document.querySelector('#calculate-button');
	let calculatorInput = calculate_button.parentNode.parentNode // .screen-00
	let calculatorOutput = calculatorInput.nextElementSibling // .screen-01
	let screen_switch_link = document.querySelectorAll('.switch-screens');
	let block_link = document.querySelector('#block-link');
	let choice_link = document.querySelector('#choice-link');
	let reset_button = document.querySelector('#reset-calculator');
	let subScreenContainer = document.querySelector('.sub-screen').parentNode;
	let subScreens = document.querySelectorAll('.sub-screen');
	let subScreen_1 = document.querySelector('.sub-screen.sub-screen-01');
	let subScreen_2 = document.querySelector('.sub-screen.sub-screen-02');
	let copy_screen_0 = calculator_container.querySelector('.header-copy.screen-00');
	let copy_screen_1 = calculator_container.querySelector('.header-copy.screen-01');
	let copy_screen_2 = calculator_container.querySelector('.header-copy.screen-02');
	let screen_copy_container = document.querySelector('#screen-copy-container');
	let kwh_warning = document.querySelector('#no_kwh_amount');
	// Calculation Variables
	let calculation_type_wrap = document.getElementById('calculation-type');
	let calculation_type = 'kWh'; // Starts on bill
	let amount_entry_field = document.querySelector('#amount-entry-field')
	let amount_entry_field_wrap = document.querySelector('.amount-entry-field-wrap')
	let avg_bill = calculator_container.dataset.avgBill;
	let avg_kwh = calculator_container.dataset.avgKwh;
	let original_input_amount;
	let avg_amount_checkbox = document.querySelector('#average-amount-checkbox');
	let existing_value; // Create it, update it later
	let habitat_support_choice = document.querySelector('#habitat-support-choice');
	// BLOCK
	let block_number;
	let block_price;
	let block_percentage_match;
	let block_amount_input = document.querySelector('#block-amount');
	let block_amount_copy_wrap = document.querySelectorAll('.block-amount-copy-wrap');
	let habitat_support_block = document.querySelector('#habitat-support-block');
	let block_cost_wrap = document.querySelector('#block-cost-wrap').querySelector('span');
	let block_cost_copy_wrap = document.querySelector('#block-cost-copy-wrap');
	let block_selection_wrap = document.querySelector('#block-selection-wrap');
	let block_percentage_wrap = document.querySelectorAll('.block-percentage-wrap');
	let block_amount_copy;
	let block_habitat_cost_wrap = document.querySelector('#habitat-block-cost-wrap');
	// Impact Variables
	let impact_period_wrap = document.querySelector('#impact-period');
	let impact_period = 'month';
	let impact_selection_wrap = document.querySelector('#impact-selector-wrap');
	let impact_arrow = document.querySelector('#impact-arrow');

	// If warning, remove warning on focus
	amount_entry_field.addEventListener('focus', e => {
		if(kwh_warning.style.display === "block") {
			kwh_warning.style.display = "none"
		} 		
	})

	// Max value on input
	amount_entry_field.addEventListener('input', e=>{
		if(parseFloat(e.target.value) > 5000) {
			e.target.value = 5000
		} else if(parseFloat(e.target.value) < 1) {
			e.target.value = 1
		}
	})

	// State Avg Checkbox
	avg_amount_checkbox.addEventListener('change', e => {
		if(avg_amount_checkbox.checked) {
			amount_entry_field.disabled = true;
			amount_entry_field.value = avg_kwh;
		} else {
			amount_entry_field.disabled = false
			amount_entry_field.value = "";
		}
		if(kwh_warning.style.display === "block") {
			kwh_warning.style.display = "none"
		} 
		// if(calculation_type === 'bill') {
		// 	if(avg_amount_checkbox.checked) {
		// 		amount_entry_field.value = avg_bill;
		// 	} 
		// } else {
		// 	if(avg_amount_checkbox.checked) {
		// 	}
		// }
	})
	// Impact Calc Function
	function impactCalculation(kwh) {
		// CHOICE - Run before Month/Year Update
		let choice_cost;
		if(habitat_support_choice.checked) {
			choice_cost = (parseFloat(kwh * 0.0094) + parseFloat(2.5)).toFixed(2);
		} else {
			choice_cost = parseFloat(kwh * 0.0094).toFixed(2);
		}
		let choice_cost_html = document.querySelectorAll('.choice-cost');
		choice_cost_html.forEach(e=>{
			e.textContent = choice_cost;
		})

		// Monthly/ Yearly
		if(impact_period === 'year') {
			kwh = parseFloat(kwh) * 12;
		}

		// - Equivalencies
		let eq_ev = Math.round(parseFloat(kwh) / 12.09);
		let eq_streaming = Math.round(parseFloat(kwh) / 0.077);
		let eq_ebike = Math.round(parseFloat(kwh) / 0.015);
		let eq_ebike_esp = Math.round(parseFloat(kwh) / 0.009);
		let eq_dishwasher = Math.round(parseFloat(kwh) / 1.17);

		// - Copy Vars
		let eq_ev_wrap = document.querySelector('.animation-wrap[data-animation="ev"]').querySelector('.eqivalency-number');
		let eq_streaming_wrap = document.querySelector('.animation-wrap[data-animation="streaming"]').querySelector('.eqivalency-number');
		let eq_ebike_wrap = document.querySelector('.animation-wrap[data-animation="ebike"]').querySelector('.eqivalency-number');;
		let eq_ebike_esp_wrap = document.querySelector('.animation-wrap[data-animation="ebike"]').querySelector('.eqivalency-number.esp');;
		let eq_dishwasher_wrap = document.querySelector('.animation-wrap[data-animation="dishwasher"]').querySelector('.eqivalency-number');;

		// - Copy Updates
		eq_ev_wrap.textContent = eq_ev.toLocaleString();
		eq_streaming_wrap.textContent = eq_streaming.toLocaleString();
		eq_ebike_wrap.textContent = eq_ebike.toLocaleString();
		if(eq_ebike_esp_wrap){ // Doesn't exist on English calc
			eq_ebike_esp_wrap.textContent = eq_ebike_esp.toLocaleString();
		}
		eq_dishwasher_wrap.textContent = eq_dishwasher.toLocaleString();
	}
	// Set Block Amounts
	function setBlockAmounts(kwh) {
		if(kwh < 100) { // Manually set block to 1 if the math won't
			block_number = 1
		} else {
			block_number = Math.floor(parseFloat(kwh) / 200);
		}
		block_price = (parseFloat(block_number) * 1.88).toFixed(2);
		block_percentage_match = Math.round(((parseFloat(block_number) * 200) / kwh) * 100);
		block_amount_input.value = block_number;
	}
	// Update Block Copy
	function updateBlockCopy(kwh) {
		block_price = (parseFloat(block_number) * 1.88).toFixed(2);
		
		if(habitat_support_block.checked == true) {
			block_price = (parseFloat(block_price) + 2.50).toFixed(2);
		}

		let original_kwh = calculator_container.dataset.originalInput;
		block_percentage_match = Math.round(((parseFloat(block_number) * 200) / original_kwh) * 100);
		// Monthly/ Yearly
		if(impact_period === 'year') {
			kwh = parseFloat(kwh) * 12;
		}
		// Block Amount Copy
		if(block_number != 1) {
			block_amount_copy = block_number + " <span class='lang-eng'>blocks</span><span class='lang-esp'>bloques</span>"
		} else {
			block_amount_copy = block_number + "  <span class='lang-eng'>block</span><span class='lang-esp'>bloque</span>"
		}
		block_amount_copy_wrap.forEach(e=>{
			e.innerHTML = block_amount_copy;
		})
		block_cost_wrap.textContent = block_price;
		block_cost_copy_wrap.textContent = block_price;
		block_percentage_wrap.forEach(e=>{
			e.textContent = block_percentage_match;
		});
		// Habitat cost
		// let block_habitat_cost = (parseFloat(block_price) + 2.50).toFixed(2);
		block_habitat_cost_wrap.textContent = block_price;
	}

	// Calculate!
	calculate_button.addEventListener('click', (e) => {
		// Variables
		// let amount_entered = amount_entry_field.value
		// Calculation amount updated 12/24
		let original_amount = amount_entry_field.value;
		let amount_entered = parseFloat(0.73 * amount_entry_field.value);
		let choice_kwh;
		if(!amount_entered) { // Make sure a value is entered
			kwh_warning.style.display = "block";
			return; 
		}
		window.scrollTo({top: 50, behavior: 'smooth'})

		// // Calculations
		// if(calculation_type == 'kWh') {
		// 	choice_kwh = amount_entered;
		// } else {
		// 	choice_kwh = Math.floor(amount_entered / .1622);
		// }

		choice_kwh = amount_entered;

		// Set original calculation value
		calculate_button.closest('#calculator-container').dataset.originalInput = choice_kwh;
		original_input_amount = calculator_container.dataset.originalInput;

		// Run the impact calcs
		impactCalculation(choice_kwh);
		// Set block Amounts
		setBlockAmounts(choice_kwh)
		// Update Block Copy
		updateBlockCopy(choice_kwh)

		// Screen Management Goes here
		// - Remove intro copy
		let active_copy = document.querySelector('.active-copy');
		active_copy.classList.remove('active-copy'); // Remove active copy
		// Show below average copy if their amount is below average for $ and kWh
		let below_avg_copy = calculator_container.querySelector('.header-copy.below-average-copy');
		if(calculation_type == 'bill'){ // 'Block' v 'Blocks'
			if(amount_entered < avg_bill) { // Below avg
				below_avg_copy.classList.add('active-copy')
			}
		} else { // kWh
			if(parseFloat(original_amount) < parseFloat(avg_kwh)) { // Below avg
				below_avg_copy.classList.add('active-copy')
			}
		}
		calculatorInput.classList.remove('active-screen')
		calculatorInput.classList.add('hidden');
		calculatorOutput.classList.remove('hidden')
		calculatorOutput.classList.add('active-screen');
	});

	// Reset Calculator
	reset_button.addEventListener('click', (e) => {
		let copy_active = calculator_container.querySelector('.header-copy.active-copy');
		let calculator_top = calculator_container.getBoundingClientRect();
		let screen_copy_top = screen_copy_container;
		window.scrollTo({top: 50, behavior: 'smooth'})

		calculatorOutput.classList.remove('active-screen')
		calculatorOutput.classList.add('hidden');
		calculatorInput.classList.remove('hidden')
		calculatorInput.classList.add('active-screen');
		if(copy_active) { // If there's active copy...
			copy_active.classList.remove('active-copy');
		}
		copy_screen_0.classList.add('active-copy');
		amount_entry_field.disabled = false;
		amount_entry_field.value = "";
		avg_amount_checkbox.checked = false; 
		calculation_type = 'kWh'
		amount_entry_field_wrap.dataset.calculationType = 'kWh'
		document.querySelector('[role^=switch]').ariaChecked = "false";
		subScreen_1.classList.add('active');
		subScreen_2.classList.remove('active');
		habitat_support_choice.checked = false;
		habitat_support_choice_off();
		habitat_support_block.checked = false;
		habitat_support_block_off()
		// - Impact
		impact_period_wrap.dataset.calculationType = 'month'
		impact_period = 'month';
		impact_period_wrap.querySelector('[role^=switch]').ariaChecked = "false";
		document.querySelector('.active-animation').classList.remove('active-animation');
		
		document.querySelector('li.active-icon').classList.remove('active-icon');
		document.querySelector('div[data-animation="ev"]:not(#impact-arrow)').classList.add('active-animation');
		document.querySelector('li[data-animation="ev"]').classList.add('active-icon');
		impact_arrow.dataset.animation = 'ev';

	});
	// Switch Sub Screens
	function switch_sub_screens() {
		let active = document.querySelector('.sub-screen.active');
		let inactive = document.querySelector('div.sub-screen:not(.active)');
		active.classList.remove('active');
		inactive.classList.add('active');
	}
	// Switch between Choice & Block
	screen_switch_link.forEach(e=>{
		e.addEventListener('click', (f) => {
			f.preventDefault();
			let parent = f.target.closest('.switch-screens');
			let parent_classList = parent.classList;
			switch_sub_screens();
			window.scrollTo({top: 50, behavior: 'smooth'})
			
			// Update subhead copy
			let copy_active = calculator_container.querySelector('.active-copy');
			if(copy_active) {
				copy_active.classList.remove('active-copy');
			}			
			if(parent_classList.contains('block')){
				// Run Block calculations for impact
				let block_kwh = parseFloat(block_amount_input.value) * 200
				impactCalculation(block_kwh);
				// Manage copy
				copy_screen_2.classList.add('active-copy');
			} else {
				// Run choice calculations for impact
				impactCalculation(original_input_amount);
				// Manage copy
				if(parseFloat(original_input_amount) < parseFloat(avg_kwh)) {
					copy_screen_1.classList.add('active-copy');
				}
			}
		});
	})
	
	// $/kWh switch
	function change_calculation_type() {
		if(!amount_entry_field.value) {
			if(calculation_type == 'bill') {
				calculation_type_wrap.dataset.calculationType = 'kWh'
				amount_entry_field_wrap.dataset.calculationType = 'kWh'
				calculation_type = 'kWh';
			} else {
				calculation_type_wrap.dataset.calculationType = 'bill'
				amount_entry_field_wrap.dataset.calculationType = 'bill'
				calculation_type = 'bill';
			}
		} else { // there's a value in the field
			if(amount_entry_field.disabled == true) {
				if(calculation_type == 'bill') {
					amount_entry_field.value = avg_kwh
					calculation_type_wrap.dataset.calculationType = 'kWh'
					amount_entry_field_wrap.dataset.calculationType = 'kWh'
					calculation_type = 'kWh';
				} else {
					amount_entry_field.value = avg_bill
					calculation_type_wrap.dataset.calculationType = 'bill'
					amount_entry_field_wrap.dataset.calculationType = 'bill'
					calculation_type = 'bill';
				}
			} else {
				if(calculation_type == 'bill') {
					// Temp calcs only
					amount_entry_field.value = amount_entry_field.value * 4
					calculation_type_wrap.dataset.calculationType = 'kWh'
					amount_entry_field_wrap.dataset.calculationType = 'kWh'
					calculation_type = 'kWh';
				} else {
					// Temp calcs only
					amount_entry_field.value = amount_entry_field.value / 4
					calculation_type_wrap.dataset.calculationType = 'bill'
					amount_entry_field_wrap.dataset.calculationType = 'bill'
					calculation_type = 'bill';
				}
			}
		}
	}
	// Change impact period: month/year
	function change_impact_period() {
		let equivalency_numbers = document.querySelectorAll('.eqivalency-number');
		if(impact_period == 'month') {
			impact_period_wrap.dataset.impactPeriod = 'year'
			impact_period = 'year';
			equivalency_numbers.forEach(e=>{
				let yearly_amount = Math.round(parseFloat(e.textContent.replace(/,/g,'') * 12));
				e.textContent = yearly_amount.toLocaleString();
			})
		} else {
			impact_period_wrap.dataset.impactPeriod = 'month'
			impact_period = 'month';
			equivalency_numbers.forEach(e=>{
				let monthly_amount = Math.round(parseFloat(e.textContent.replace(/,/g,'')) / 12);
				e.textContent = monthly_amount.toLocaleString();
			})
		}
	}
	// Set calculation type
	// calculation_type_wrap.addEventListener('click', (e) => {
	// 	change_calculation_type();
	// });
	// Set impact period
	impact_period_wrap.addEventListener('click', (e) => {
		change_impact_period();
	});

	// Add Habitat
	// - Choice
	function habitat_support_choice_switch() {
		let parent = habitat_support_choice.closest('.body-copy')
		let plain_copy = parent.querySelector('.choice-copy:not(.habitat)')
		let habitat_copy = parent.querySelector('.choice-copy.habitat')
		let current_cost_wrap = document.querySelectorAll('.choice-cost');
		let current_cost = current_cost_wrap[0].textContent;
		if(habitat_support_choice.checked) {
			plain_copy.classList.add('hidden');
			habitat_copy.classList.remove('hidden');
			let new_cost = (parseFloat(current_cost) + 2.50).toFixed(2);
			current_cost_wrap.forEach(e=>{
				e.textContent = new_cost;
			});
		} else {
			plain_copy.classList.remove('hidden');
			habitat_copy.classList.add('hidden');		
			let old_cost = (parseFloat(current_cost) - 2.50).toFixed(2);
			current_cost_wrap.forEach(e=>{
				e.textContent = old_cost;
			});
		}
	}

	function habitat_support_choice_off() {
		let parent = habitat_support_choice.closest('.body-copy')
		let plain_copy = parent.querySelector('.choice-copy:not(.habitat)')
		let habitat_copy = parent.querySelector('.choice-copy.habitat')
		let current_cost_wrap = document.querySelectorAll('.choice-cost');
		let current_cost = current_cost_wrap[0].textContent;

		plain_copy.classList.remove('hidden');
		habitat_copy.classList.add('hidden');		
		let old_cost = (parseFloat(current_cost) - 2.50).toFixed(2);
		current_cost_wrap.forEach(e=>{
			e.textContent = old_cost;
		});

	}

	habitat_support_choice.addEventListener('change', e => {
		habitat_support_choice_switch();
	});

	// - Block
	function habitat_support_block_switch() {
		let parent = habitat_support_block.closest('.inner');
		let plain_copy = parent.querySelector('.block-copy:not(.habitat)');
		let habitat_copy = parent.querySelector('.habitat-copy-wrap');
		let current_cost_wrap = document.querySelector('#block-cost-wrap').querySelector('span');
		let current_cost_copy_wrap = document.querySelector('#habitat-block-cost-wrap');
		let current_cost = current_cost_wrap.textContent;
		if(habitat_support_block.checked) {
			plain_copy.classList.add('hidden');
			habitat_copy.classList.remove('hidden');
			let new_cost = (parseFloat(current_cost) + 2.50).toFixed(2);
			current_cost_wrap.textContent = new_cost;
			current_cost_copy_wrap.textContent = new_cost;
			block_cost_copy_wrap.textContent = new_cost;
		} else {
			plain_copy.classList.remove('hidden');
			habitat_copy.classList.add('hidden');		
			let new_cost = (parseFloat(current_cost) - 2.50).toFixed(2);
			current_cost_wrap.textContent = new_cost;
			current_cost_copy_wrap.textContent = new_cost;
			block_cost_copy_wrap.textContent = new_cost;
		}
	}
	function habitat_support_block_off() {
		let parent = habitat_support_block.closest('.inner');
		let plain_copy = parent.querySelector('.block-copy:not(.habitat)');
		let habitat_copy = parent.querySelector('.habitat-copy-wrap');
		let current_cost_wrap = document.querySelector('#block-cost-wrap').querySelector('span');
		let current_cost = current_cost_wrap.textContent;
		
		plain_copy.classList.remove('hidden');
		habitat_copy.classList.add('hidden');		
		let new_cost = (parseFloat(current_cost) - 2.50).toFixed(2);
		current_cost_wrap.textContent = new_cost;
	}
	habitat_support_block.addEventListener('change', e => {
		habitat_support_block_switch()
	});

	// Block selection
	// - Manual input
	block_amount_input.addEventListener('input', e=>{
		if(parseFloat(e.target.value) > 25) {
			e.target.value = 25
		} else if(parseFloat(e.target.value) < 1) {
			e.target.value = 1
		}
		block_number = e.target.value;
		let kwh = parseFloat(e.target.value) * 200;

		console.log('kwh', kwh)
		impactCalculation(kwh)
		updateBlockCopy(kwh)
	})
	// - Buttons
	block_selection_wrap.addEventListener('click', e => {
		let target = e.target
		let block_input = document.querySelector('#block-amount');
		let current_block_value = block_input.value;
		if(isNaN(parseFloat(current_block_value)) ) {
			console.log('NaN')
			console.log(current_block_value)
			return;
		}
		if(target.classList.contains('block-button') || target.parentElement.classList.contains('block-button')) { // Parent for span in minus
			if(target.classList.contains('plus')) {
				if(current_block_value < 25) {
					current_block_value = parseFloat(current_block_value) + 1
					block_input.value = current_block_value
				}
			} else {
				if(current_block_value > 1) {
					current_block_value = current_block_value - 1
					block_input.value = current_block_value
				}
			}
		}
		block_number = current_block_value
		let kwh = parseFloat(current_block_value) * 200;
		impactCalculation(kwh)
		updateBlockCopy(kwh)
	})

	// Icon functionalities
	function switchIcons(target) {
		if(target.classList.contains('inactive-impact-icon')){
			let target_parent = target.closest('.impact-icon');
			let target_type = target_parent.dataset.animation;
			let active_icon = document.querySelector('li.active-icon');
			let active_icon_type = active_icon.dataset.animation;
			let active_animation = document.querySelector('.active-animation');
			let target_animation = document.querySelector('div[data-animation='+CSS.escape(target_type)+']');
			if(active_icon_type != target_type) { // Only change the icon if the user clicks on a non-active icon
				// Remove the active icon
				active_icon.classList.remove('active-icon');
				// Add the active icon
				target_parent.classList.add('active-icon');
				// Deactivate the active animation
				active_animation.classList.remove('active-animation');
				// Activate the new animation
				target_animation.classList.add('active-animation');
				// Move the arrow
				impact_arrow.dataset.animation = target_type;
			}
		}
	}
	impact_selection_wrap.addEventListener('click', e => {
		console.log('e',e);
		let target = e.target

		switchIcons(target)
	})
	impact_selection_wrap.addEventListener('keydown', e => {
		console.log('e',e);
		if (event.keyCode === 13 && !e.target.classList.contains('active-icon')) {
			let target = e.target.querySelector('img.inactive-impact-icon')
			switchIcons(target)
		}
	})

	// Leftovers
	// - Resize Calculator container
	// function calcResize() {
	// 	let activeScreen = document.querySelector('.active-screen');
	// 	let screenName = activeScreen.id;
	// 	let activeHeight = activeScreen.offsetHeight;
	// 	screensWrap.style.height = activeHeight + 'px'; 
	// 	console.log('screenName', screenName);
	// 	console.log('activeHeight', activeHeight);
	// };
	// window.addEventListener("load", () => { // Run once on load
	// 	// calcResize();
	// });

	// Set height of #cost-breakdown-container
	// function susbscreen_resize() {
	// 	let screenHeights = [];
	// 	console.log('subScreenContainer',subScreenContainer)
	// 	console.log('subScreens',subScreens)
	// 	// subScreens.forEach(element => console.log(element))
	// 	subScreens.forEach(
	// 		element => screenHeights.push(element.offsetHeight)
	// 	);
	// 	console.log(screenHeights);
	// 	let containerHeight= Math.max(...screenHeights);
	// 	console.log(containerHeight);
	// 	subScreenContainer.style.height = containerHeight + 'px';
	// };
} // if calculator container

// WP Go Maps
// - RDF Map
// Old active function
// const filterLists = document.getElementsByClassName("tdi_filter_list");
// [...filterLists].forEach(fl => {
// 	fl.addEventListener('click', function(e){
		
// 		if((e.target.tagName == 'LABEL') || (e.target.parentNode.tagName == 'LABEL')) {
			
// 		}
// 	})
// })

// WP GO Maps Marker filtering - Disabling empty filters
jQuery(document.body).on("postinit.wpgmza", function () {
	setTimeout(() => { // CGPT's load function didn't work, so we're manually adding wait time

		const map = WPGMZA.maps[0];
		const markers = map.markers
		const filterContainer = document.getElementById('rdf-filter-container');
		var enableGroup = [];
		var activeCategories = [];

		function getCategoryNumber(attrFor) {
			catNumber = attrFor.slice(-2);
			if(catNumber.includes('_')) {
				catNumber = catNumber.split('_')[1];
			}
			return catNumber
		}
		function removeItemFromArray(array, itemToRemove) {
		    const index = array.indexOf(itemToRemove);
		    if (index !== -1) {
		        array.splice(index, 1);
		    }
		}

		filterContainer.addEventListener('click', function(e){
		// Set active labels and categories
			if(e.target.tagName == 'LABEL' || e.target.parentNode.tagName == 'LABEL') {
				var label = e.target.closest('label');
				var attrFor = label.getAttribute('for');

				if(e.target.closest('label').classList.contains('active')) { // Deactivate!
					label.classList.remove('active');
					var catToRemove = getCategoryNumber(attrFor);
					removeItemFromArray(activeCategories, catToRemove);
				} else { // Activate!
					e.target.closest('label').classList.add('active') 
					activeCategories.push(getCategoryNumber(attrFor));
				}
			// After active/inactive, get total number of active labels/filters
				var catNumber;
				const allLabels = filterContainer.querySelectorAll('label');
				const activeLabelCount = document.querySelectorAll('label.active').length;
				
			// Handle enable/disable of labels
				if(activeLabelCount == 0) {
					enableGroup = [];
					activeCategories = [];
					[...allLabels].forEach(e => e.classList.remove('disabled'));	
				} else {
					enableGroup = [];
					[...allLabels].forEach(e => e.classList.add('disabled'));	
				// Collect all markers that contain this catNumber
					markers.forEach(e => {
						if(activeCategories.every(catNumber => e.categories.includes(catNumber))) { 
							enableGroup.push(...e.categories)
						}
					});
					enableGroup = [...new Set(enableGroup)] // De-dup the array
					enableGroup.forEach(e => {
						const searchString = 'wpgmza_cat_checkbox_' + e;
						const activeLabel = document.querySelectorAll('[for="'+ searchString +'"]');
						activeLabel[1].classList.remove('disabled'); // 1 not 0 bc of the WPGMZA standalone that has copies
					})
				} 
			}
		})

		// Clear all filters
		const clearFiltersButton = document.getElementById("clear-all-filters");
		if(clearFiltersButton) {
			clearFiltersButton.addEventListener('click', function(){
				activeCategories = [];
				Array.from(document.querySelectorAll('label.active')).forEach(
				  (el) => el.classList.remove('active')
				);
				Array.from(document.querySelectorAll('label.disabled')).forEach(
				  (el) => el.classList.remove('disabled')
				);
				Array.from(document.querySelectorAll('input[type=checkbox]:checked')).forEach(
				  (el) => el.click()
				);
			})
		}
	}, "1200");
});
